import accountApi from '@/modules/account-api';
import http from '@/modules/http';

export default {

	getAccountInfo() {
		return accountApi.getAccountInfo();
	},

	getReceipts() {
		return accountApi.getReceipts();
	},

	getSubscriptions(payload) {
		return accountApi.getSubscriptions(payload);
	},

	changeSubscription(payload) {
		return accountApi.changeSubscription(payload);
	},

	addSubscription(payload) {
		return accountApi.addSubscription(payload);
	},

	getMaintenanceOptions(subscriptionId) {
		return accountApi.getMaintenanceOptions(subscriptionId);
	},

	purchaseMaintenanceExtension(subscriptionId, maintenanceExtensionId, quantity) {
		return accountApi.purchaseMaintenanceExtension(subscriptionId, maintenanceExtensionId, quantity);
	},

	getOneTimePaymentResponse(oneTimePurchaseId) {
		let pollingTimer = null;
		let attempts = 0;
		return new Promise((resolve, reject) => {
			return accountApi.getOneTimePaymentResponse(oneTimePurchaseId)
				.then(function pollPaymentStatus(resp) {
					if (resp.status === 'pending') {
						attempts++;
						if (attempts >= 20) {
							reject({message: 'POLLING_ERROR'});
						}
						pollingTimer = setTimeout(() => {
							return accountApi.getOneTimePaymentResponse(oneTimePurchaseId)
								.then(pollPaymentStatus);
						}, 500);
					}

					if (resp.status === 'success') {
						console.log('Stripe Success');
						clearTimeout(pollingTimer);
						resolve(resp);
					}
				}, reject);
		});
	},

	purchaseExtensionAndPollStatus(subscriptionId, maintenanceExtensionId, quantity) {
		return accountApi.purchaseMaintenanceExtension(subscriptionId, maintenanceExtensionId, quantity)
			.then((oneTimePurchaseId) => {
				return this.getOneTimePaymentResponse(oneTimePurchaseId)
					.then((successResp) => {
						return successResp;
					}, http.rejectData);
			});
	},

	getPromotion(payload) {
		return accountApi.getPromotion(payload);
	},

	addPromotion(payload) {
		return accountApi.addPromotion(payload);
	},

	removeSubscription(subId) {
		return accountApi.removeSubscription(subId);
	},

	getPlans(payload) {
		return accountApi.getPlans(payload);
	},

	getPlansV2(payload) {
		return accountApi.getPlansV2(payload);
	},

	getScopePlansV2(payload) {
		return accountApi.getScopePlansV2(payload);
	},

	getPlanAddOns(planId) {
		return accountApi.getPlanAddOns(planId);
	},

	addPaymentMethod(payload) {
		return accountApi.addPaymentMethod(payload);
	},

	getEstimatedTax(zip) {
		return accountApi.getEstimatedTax(zip);
	}

};



// WEBPACK FOOTER //
// ./src/modules/account-service.js